<template>
	<div
		:class="{
		'trial_alert':true,
		'trial_alert_ott':($store.state.router.type == 'ott'?true:false)
	}"
	>
		<div class="trial_alert_wrap">
			<div class="trial_alert_card">
				<div class="trial_alert_card_title">提速卡</div>
				<div class="trial_alert_card_desc">上网就是快</div>
				<div class="trial_alert_card_speed">
					{{$store.state.toDownSpeed}}
					<div class="trial_alert_card_mbps">Mbps</div>
				</div>

				<a href="javascript:;" class="trial_alert_close" @click="onCloseClick"></a>
			</div>
			<div class="trial_alert_title">
				恭喜您！获得
				<span class="trial_alert_title_num"></span>张提速卡，
				<a href="javascript:;" @click="onTrialClick">立即使用</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		onCloseClick: function() {
			let _that = this;
			_that.$emit("onCloseClick");
		},
		onTrialClick: function() {
			let _that = this;
			_that.$emit("onTrialClick");
		}
	},
	directives: {
		focus: {
			// 指令的定义
			inserted: function(el) {
				el.focus();
			}
		}
	}
};
</script>

<style lang="less" scoped>
.trial_alert {
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	z-index: 10;

	.trial_alert_wrap {
		position: absolute;
		left: 0;
		bottom: 0;
		height: 250px;
		width: 100%;
		background-image: url(../assets/trial_alert_bg.png);
		background-position: center 120px;
		background-repeat: no-repeat;
		background-size: 110% 55%;

		.trial_alert_card {
			width: 668px;
			height: 234px;
			position: absolute;
			left: 50%;
			margin-left: -320px;
			top: 0;
			background-image: url(../assets/trial_alert_card_bg.png);
			background-repeat: no-repeat;
			background-size: 100% 100%;
			z-index: 1;

			.trial_alert_card_title {
				color: #ffffff;
				font-size: 32px;
				font-weight: bolder;
				margin-top: 70px;
				margin-left: 204px;
			}

			.trial_alert_card_desc {
				color: #ffffff;
				font-size: 18px;
				margin-left: 204px;
				margin-top: 5px;
			}

			.trial_alert_card_speed {
				position: absolute;
				top: 65px;
				right: 225px;
				color: #f13b3b;
				font-size: 42px;
				text-align: center;
				width: 100px;
				.trial_alert_card_mbps {
					font-size: 18px;
					color: #3f0608;
				}
			}

			.trial_alert_close {
				position: absolute;
				top: 65px;
				right: -210px;
				width: 50px;
				height: 50px;
				background-image: url(../assets/trial_alert_close.png);
				background-size: 100%;
				display: block;
			}
			.trial_alert_close:active {
				transform: scale(1.2);
			}
		}

		.trial_alert_title {
			font-size: 32px;
			width: 100%;
			color: #f95050;
			top: 190px;
			text-align: center;
			z-index: 2;
			position: absolute;
			left: 0;

			.trial_alert_title_num {
				background-image: url(../assets/trial_alert_num.png);
				background-repeat: no-repeat;
				background-size: 100%;
				width: 18px;
				height: 64px;
				display: inline-block;
				vertical-align: middle;
				margin: 0 10px 0 5px;
			}

			a {
				font-weight: bolder;
				color: #f95050;
				border-bottom: 2px solid #523c09;
			}

			a:active {
				font-size: 38px;
				border-bottom: 4px solid #523c09;
				outline: 0;
			}
		}
	}
}
</style>